package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.repository.RouteRepository

/** DELETE /api/v1/routes/{routeId}/deliveries/{deliveryId} (MIL-55 — écran 07b, croix rouge sur un arrêt). */
class RemoveDeliveryFromRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String, deliveryId: String) =
        repository.removeDeliveryFromRoute(routeId, deliveryId)
}
